import SvgIcon, { SvgIconProps } from "./SvgIcon";

const GlobeIcon: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1973 3C7.22695 3 3.19727 7.02969 3.19727 12C3.19727 16.9703 7.22695 21 12.1973 21C17.1676 21 21.1973 16.9703 21.1973 12C21.1973 7.02969 17.1676 3 12.1973 3Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
      <path
        d="M17.5815 4.90177C17.5815 4.90177 13.8476 11.1526 21.197 11.9992"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
      <path
        d="M20.2523 15.9925C20.2523 15.9925 17.6593 15.8137 16.2261 15.0743C15.6597 14.7821 15.065 14.2942 14.5457 13.8019C13.8431 13.1359 12.6217 13.3402 12.2812 14.2465C11.6582 15.9052 11.5197 17.7067 11.8818 19.4411L12.1668 20.8065"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
      <path
        d="M5.29443 17.6908L6.99014 16.1419C8.06347 15.1614 8.4974 13.6626 8.11383 12.2603L8.01756 11.9084C7.56424 10.2512 8.39848 8.51284 9.9749 7.82973C11.42 7.20353 12.258 5.67872 12.0122 4.12309L11.8347 3"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
    </SvgIcon>
  );
};

export default GlobeIcon;
